import { ProductImageRequestDto } from '@tiendanube/common';
import ProductMediaRequestDto from '@tiendanube/common/src/domains/catalog/interfaces/ProductMediaRequest';
import {
  DeleteImagesRequest,
  UpdateImagesRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/ImagesRequest';
import {
  DeleteMediaRequest,
  UpsertMediaRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/MediaRequest';
import {
  ImageGalleryState,
  MediaGalleryState,
} from 'domains/Catalog/Products/pages/components/ImageGallery/ImageGallery';

type ImagesPayload = (UpdateImagesRequest | DeleteImagesRequest)[];

export const generateImagesPayload = (
  originalImages: ImageGalleryState[],
  newImages: ProductImageRequestDto[] | undefined,
): { images: ImagesPayload } | undefined => {
  if (!newImages) {
    return undefined;
  }
  const imagesToUpsert: UpdateImagesRequest[] = [];
  const imagesToDelete: DeleteImagesRequest[] = [];

  const newIds = new Set(newImages.map((i) => String(i.image_id)));
  originalImages.forEach((image) => {
    if (!newIds.has(String(image.id))) {
      imagesToDelete.push({ id: Number(image.id), '@delete': true });
    }
  });

  newImages.forEach((image, index) => {
    if (image.image_id !== null) {
      imagesToUpsert.push({
        id: Number(image.image_id),
        order: index,
      });
    }
  });

  return { images: [...imagesToUpsert, ...imagesToDelete] };
};

export const generateMediaPayload = (
  originalMedia: MediaGalleryState[],
  newMedia: ProductMediaRequestDto[] | undefined,
): { media: (UpsertMediaRequest | DeleteMediaRequest)[] } | undefined => {
  if (!newMedia) {
    return undefined;
  }
  const mediaToUpsert: UpsertMediaRequest[] = [];
  const mediaToDelete: DeleteMediaRequest[] = [];

  const newIds = new Set(newMedia.map((m) => String(m.id)));
  originalMedia.forEach((media) => {
    if (!newIds.has(String(media.id))) {
      mediaToDelete.push({
        id: Number(media.id),
        type: media.mediaType,
        '@delete': true,
      });
    }
  });

  newMedia.forEach((media, index) => {
    mediaToUpsert.push({
      id: Number(media.id),
      type: media.media_type,
      order: index,
    });
  });

  return { media: [...mediaToUpsert, ...mediaToDelete] };
};
